import React from "react";

export const europeanCountries = [
  { code: "AT", name: "Austria", methods: ["paypal", "creditcard", "klarna", "trustly"] },
  { code: "BE", name: "Belgium", methods: ["paypal", "creditcard", "klarna", "trustly"] },
  { code: "BG", name: "Bulgaria", methods: ["paypal", "creditcard", "klarna", "trustly"] },
  { code: "CZ", name: "Czech Republic", methods: ["paypal", "creditcard", "klarna", "trustly"] },
  { code: "DK", name: "Denmark", methods: ["paypal", "creditcard", "klarna", "trustly"] },
  { code: "HR", name: "Croatia", methods: ["paypal", "creditcard", "klarna", "trustly"] },
  { code: "CY", name: "Cyprus", methods: ["paypal", "creditcard", "klarna", "trustly"] },
  { code: "EE", name: "Estonia", methods: ["paypal", "creditcard", "klarna", "trustly"] },
  { code: "FI", name: "Finland", methods: ["paypal", "creditcard", "klarna", "trustly"] },
  { code: "FR", name: "France", methods: ["paypal", "creditcard", "klarna", "trustly"] },
  { code: "DE", name: "Germany", methods: ["paypal", "creditcard", "klarna", "trustly"] },
  { code: "GR", name: "Greece", methods: ["paypal", "creditcard", "klarna", "trustly"] },
  { code: "HU", name: "Hungary", methods: ["paypal", "creditcard", "klarna", "trustly"] },
  { code: "IE", name: "Ireland", methods: ["paypal", "creditcard", "klarna", "trustly"] },
  { code: "IT", name: "Italy", methods: ["paypal", "creditcard", "klarna", "trustly"] },
  { code: "LV", name: "Latvia", methods: ["paypal", "creditcard", "klarna", "trustly"] },
  { code: "LT", name: "Lithuania", methods: ["paypal", "creditcard", "klarna", "trustly"] },
  { code: "LU", name: "Luxembourg", methods: ["paypal", "creditcard", "klarna", "trustly"] },
  { code: "MT", name: "Malta", methods: ["paypal", "creditcard", "klarna", "trustly"] },
  { code: "NL", name: "Netherlands", methods: ["ideal", "paypal", "creditcard", "klarna", "trustly"] },
  { code: "NO", name: "Norway", methods: ["paypal", "creditcard", "klarna", "trustly"] },
  { code: "PL", name: "Poland", methods: ["paypal", "creditcard", "klarna", "trustly"] },
  { code: "PT", name: "Portugal", methods: ["paypal", "creditcard", "klarna", "trustly"] },
  { code: "RO", name: "Romania", methods: ["paypal", "creditcard", "klarna", "trustly"] },
  { code: "SE", name: "Sweden", methods: ["paypal", "creditcard", "klarna", "trustly"] },
  { code: "SK", name: "Slovakia", methods: ["paypal", "creditcard", "klarna", "trustly"] },
  { code: "SI", name: "Slovenia", methods: ["paypal", "creditcard", "klarna", "trustly"] },
  { code: "ES", name: "Spain", methods: ["paypal", "creditcard", "klarna", "trustly"] },
  { code: "GB", name: "United Kingdom", methods: ["paypal", "creditcard", "klarna", "trustly"] },
];

export default function CountryDropdown({ selectedCountry, onChange }) {
  return (
    <select value={selectedCountry} onChange={e => onChange(e.target.value)}>
      <option value="">Select country</option>
      {europeanCountries.map(country => (
        <option key={country.code} value={country.code}>
          {country.name}
        </option>
      ))}
    </select>
  );
}